import Vue from 'vue'
import { ToastPlugin, ModalPlugin, SkeletonPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import JsonViewer from 'vue-json-viewer'

import CKEditor from '@ckeditor/ckeditor5-vue2'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(SkeletonPlugin)

Vue.use(JsonViewer)

Vue.use(CKEditor)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// const isDev = process.env.NODE_ENV !== 'production'
// Vue.config.performance = isDev

Vue.prototype.$creativeImgUrl = '//img.phoenix-widget.com/o/b'
Vue.prototype.$promotionPageImgUrl = '//api.phoenix-widget.com/images/p'
Vue.prototype.$promotionPageVideoUrl = '//video-cdn.phoenix-widget.com'

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
